import { useTranslation } from "hhn-commons";
import AlertHeaderWithDivider from "../alertItemHeader/AlertHeaderWithDivider";
import AlertsPanelHeader from "../alertItemHeader/AlertsPanelHeader";
import {
  AlertPanelHeaderContainer,
  UnstarAllButton,
} from "../alertItemHeader/AlertsPanelHeader.style";

const StarredMessageHeader = ({
  onUnstarAllClick,
  showUnstarAll,
}: {
  onUnstarAllClick: () => void;
  showUnstarAll: boolean;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const tNsStarred = (key: string) => t(key, { ns: "starredMessages" });
  return (
    <>
      <AlertHeaderWithDivider>
        <AlertPanelHeaderContainer>
          <AlertsPanelHeader alertLabel={tNs("alerts.starredMessages")} />
          {showUnstarAll && (
            <UnstarAllButton variant="outlined" onClick={onUnstarAllClick}>
              {tNsStarred("unstarAll")}
            </UnstarAllButton>
          )}
        </AlertPanelHeaderContainer>
      </AlertHeaderWithDivider>
    </>
  );
};

export default StarredMessageHeader;
